import { CategoryRatingPresenter } from '@/presentation/presenters/dashboard/categoryRatingPresenter'
import { CategoryRatingViewModel } from '@/presentation/viewmodels/dashboard/categoryRatingViewModel'

export function useCategoryRatingPresenter(
  presenter: CategoryRatingPresenter = new CategoryRatingPresenter(new CategoryRatingViewModel())
) {
  return {
    userWhatCategoryRatingList: presenter.userWhatCategoryRatingList,
    userHowCategoryRatingList: presenter.userHowCategoryRatingList,
    userProgrammingCategoryRatingList: presenter.userProgrammingCategoryRatingList,
    isLoading: presenter.isLoading,
    error: presenter.error,
    addUserCategoryRating: presenter.addUserCategoryRating.bind(presenter),
    addUserCategoryRatingByLanguage: presenter.addUserCategoryRatingByLanguage.bind(presenter),
    removeUserCategories: presenter.removeUserCategories.bind(presenter),
    removeTargetUsers: presenter.removeTargetUsers.bind(presenter)
  }
}
